<div class="loading-shade" *ngIf="isLoading ">
	<!-- || isRateLimitReached -->
	<mat-spinner diameter="80" *ngIf="isLoading"></mat-spinner>
</div>
<form [formGroup]="contactInfoForm" class="formEditSchool paddingToAll">	
	<mat-card appearance="outlined" class="cardSchoolProfile">
		<mat-card-title-group style="position:relative;">
			<span class="floatRight"><button mat-icon-button color="primary" matTooltip="Close record"
				(click)="closeRecord()"><mat-icon class="centered-icon" style="position:relative;right:3px;">close</mat-icon></button> <!-- <i class="fa-edit"></i> -->
				</span>
			<div style="display: block; width: 100%;">
				<input 
					type="text" 
					class="school-input" 
					[value]="schoolName + '\'s School Profile'" 
					readonly>
			<!-- <div class="floatRight"><button mat-icon-button color="primary" matTooltip="Edit record"
					(click)="editRecord()">
					<mat-icon>edit</mat-icon>
				</button></div> --><!-- <i class="fa-edit"></i> -->
			</div>
		</mat-card-title-group>

		<mat-card-content>
			<span style="display: block; width: 100%;  text-align:left; line-height:40px;">
				<b>Region:</b>&nbsp;&nbsp;&nbsp;<input 
				type="text" 
				class="region-input" 
				[value]="regionName + '(' + region + ')'" 
				readonly>
			</span>
			<b>County: </b>&nbsp; {{county}}<p></p>
			<b>School District: </b>&nbsp; {{district}} ({{districtCode}}) (NCES - {{ncesCode}})<p></p>
			<!-- myorgid:{{organizationId}} inpOrgId: {{inOrgId}} -->
		</mat-card-content>
	</mat-card>
	<p><br></p>
	<mat-card-title>School Information</mat-card-title>
	<!-- <mat-card class="cardSchoolInformation">
		 appearance="outlined" theme-background-color theme-font-color -->
		<!-- <mat-card-title-group class="groupSchoolInformation">
		</mat-card-title-group> 

		<mat-card-content> -->
			<table id="schoolInfoTable">
				<tr>
					<th> School Type </th>
					<td> {{schoolType}} </td>
				</tr>
				<tr>
					<th> SSID </th>
					<td> {{SSID}} </td>
				</tr>
				<tr>
					<th> CDS Code </th>
					<td> {{CDSCode}} </td>
				</tr>
				<tr>
					<th> School NCES </th>
					<td> {{NCES}} </td>
				</tr>
				<tr>
					<th> School Grade Span </th>
					<td> {{gradeSpan}} </td>
				</tr>
				<tr>
					<th> School Status </th>
					<td> {{schoolStatus}} </td>
				</tr>
				<tr>
					<th> School Property </th>
					<td> {{schoolProperty}} </td>
				</tr>
				<tr>
					<th> Closed Date </th>
					<td> {{((closedDate! | simpleDate) == '12/31/1900') ? '' : (closedDate! | simpleDate) }}</td>
				</tr>
			</table>
	<!--	</mat-card-content>
	</mat-card> -->

	<div class="row">
		<p><br></p>
		<mat-card-title>Contact Information</mat-card-title>
		<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
			<mat-card appearance="outlined">
				<mat-card-content>
					<view-party-contact-mechanism *ngIf="(partyIdNum > 0)" [partyId]="partyIdNum"
						[enabledTypes]="['contactPersons','postalAddresses', 'emails','phoneNumbers']"
						[filterAddressTypes]="['Work Address']"
						[filterPhoneNumberTypes]="['Home Phone', 'Cell Phone', 'Work Phone', 'Other Phone']"
						[removeAddressTypes]="['Birthplace Address']"></view-party-contact-mechanism>
				</mat-card-content>
			</mat-card>
		</div>
	</div>

</form>